import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconDownloadingStyle0 = cosmosIconCss;

const CosmosIconDownloading$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDownloading extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'f5272aaf62bd120006523e1455a6f96907f7f3ae', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'd9fcd839b4ee8812ed36f85951f98340005b6664', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '73809e31dc12ddc709fd53ba03e5b42f3a8afca3', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.857 6a.5.5 0 0 0-.5-.5H8.5A.5.5 0 0 0 8 6v7a.5.5 0 0 0 .5.5h1.857a.5.5 0 0 0 .5-.5V6ZM16 6a.5.5 0 0 0-.5-.5h-1.857a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5H15.5a.5.5 0 0 0 .5-.5V6Z", fill: "currentColor" }), h("mask", { key: '87ff579176192f888858347a107028afb73d9217', id: "a", maskUnits: "userSpaceOnUse", x: "0", y: "9", width: "12", height: "12" }, h("path", { key: 'cf85e4187a1223bdfb5cc9372e28a1c0ea14d177', fill: "#fff", d: "M.75 9.75H12v11H.75z" })), h("g", { key: '91ef58c4919042724064f3d515f51e7df03c4b01', mask: "url(#a)" }, h("path", { key: '842a4bbe43fb5e3b94fca145aca7e74a264cdac3', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 .5a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM12 2c4.136 0 7.5 3.367 7.5 7.5S16.136 17 12 17c-4.135 0-7.5-3.367-7.5-7.5C4.5 5.368 7.864 2 12 2Z", fill: "#DB0A40" })))));
    }
    static get style() { return CosmosIconDownloadingStyle0; }
}, [1, "cosmos-icon-downloading", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-downloading"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-downloading":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDownloading$1);
            }
            break;
    } });
}

const CosmosIconDownloading = CosmosIconDownloading$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDownloading, defineCustomElement };
